// services/unaffiliatedMemberReport.ts
import api from './api';
import { 
  UnaffiliatedMemberData, 
  GroupedMemberData, 
  OvertimeSummary,
  UnaffiliatedMemberListResponse,
  GroupedMemberResponse,
  OvertimeSummaryResponse,
  UnaffiliatedMemberSearchParams
} from '../types/unaffiliatedMemberReport';

export const unaffiliatedMemberReportService = {
  // 選択した月の無所属メンバー一覧を取得
  getByMonth: async (year: number, month: number): Promise<UnaffiliatedMemberListResponse> => {
    try {
      const response = await api.get<UnaffiliatedMemberListResponse>(
        `/unaffiliated-member-report/list?year=${year}&month=${month}`
      );

      if (!response.data || !response.data.reports) {
        throw new Error('無所属メンバーデータの取得に失敗しました');
      }
      
      return response.data;
    } catch (error) {
      console.error('無所属メンバー一覧の取得に失敗:', error);
      throw error;
    }
  },

  // メンバーごとにグループ化したデータを取得
  getGroupedByMonth: async (year: number, month: number): Promise<GroupedMemberResponse> => {
    try {
      const response = await api.get<GroupedMemberResponse>(
        `/unaffiliated-member-report/grouped?year=${year}&month=${month}`
      );

      if (!response.data || !response.data.members) {
        throw new Error('グループ化データの取得に失敗しました');
      }
      
      return response.data;
    } catch (error) {
      console.error('グループ化データの取得に失敗:', error);
      throw error;
    }
  },

  // 残業時間のサマリーを取得
  getOvertimeSummary: async (year: number, month: number): Promise<OvertimeSummaryResponse> => {
    try {
      const response = await api.get<OvertimeSummaryResponse>(
        `/unaffiliated-member-report/overtime-summary?year=${year}&month=${month}`
      );

      if (!response.data || !response.data.summary) {
        throw new Error('残業時間サマリーの取得に失敗しました');
      }
      
      return response.data;
    } catch (error) {
      console.error('残業時間サマリーの取得に失敗:', error);
      throw error;
    }
  },

  // メンバー名で検索
  searchByName: async (params: UnaffiliatedMemberSearchParams): Promise<UnaffiliatedMemberListResponse> => {
    try {
      // URLクエリパラメータを構築
      const queryParams = new URLSearchParams();
      queryParams.append('year', params.year.toString());
      queryParams.append('month', params.month.toString());
      
      // メンバー名がある場合のみ追加
      if (params.memberName) {
        queryParams.append('name', params.memberName);
      }
      
      // 検索APIを呼び出し
      const response = await api.get<UnaffiliatedMemberListResponse>(
        `/unaffiliated-member-report/search?${queryParams.toString()}`
      );
      
      if (!response.data) {
        throw new Error('無所属メンバーの検索に失敗しました');
      }
      
      return response.data;
    } catch (error) {
      console.error('無所属メンバー検索エラー:', error);
      throw error;
    }
  }
};